export const GET_ALL_CURRENCY_REQUEST = "GET_ALL_CURRENCY_REQUEST";
export const GET_ALL_CURRENCY_FAILURE = "GET_ALL_CURRENCY_FAILURE";
export const GET_ALL_CURRENCY_SUCCESS = "GET_ALL_CURRENCY_SUCCESS";